import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LstUserService } from '@savvaslearning/lst-auth';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { from } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { CommandAction } from '../../shared/models/constants';
import { SharedService } from '../../shared/services/shared.service';
import { environment } from './../../../environments/environment';

@NgModule({
  exports: [HttpClientModule, ApolloModule, HttpLinkModule],
})
export class GraphqlModule {
  constructor(
    readonly apollo: Apollo,
    private readonly httpLink: HttpLink,
    private readonly lstUserService: LstUserService,
    private readonly sharedService: SharedService,
  ) {
    apollo.create({
      link: from([this.authMiddleware(), this.errorAfterware(), this.http()]),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      },
    });
  }

  private authMiddleware() {
    return setContext((_, { headers }) => {
      // get the rbs token from session storage if it exists
      const rbsToken = this.lstUserService.getRbsToken();
      // return the headers to the context so httpLink can read them
      return {
        headers: {
          ...headers,
          authorization: rbsToken ? `Bearer ${rbsToken}` : '',
        },
      };
    });
  }

  private http() {
    const uri = `${environment.backendForFrontend.url}${environment.backendForFrontend.apiPath}`;
    return this.httpLink.create({ uri });
  }

  private errorAfterware() {
    return onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        });
      }
      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
      }
      this.sharedService.setCommandQuery({
        action: CommandAction.NAVIGATE_TO_ERROR,
      });
    });
  }
}
